import * as FAM from "model/FlexibleAttributeModel";
import { BaseJsonTransformer } from "./IJsonTransformer";
import { v4 as uuidv4 } from 'uuid';
import { FieldsToLookupByMasterAttributeId } from "global/Application";

/**
 * 
 * Shared Savings Transformer
 * Transformer:
 * https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/412925
 */
export class Sprint22Transformer extends BaseJsonTransformer {
    config: FAM.IGroupConfigurationConfig;
    json: FAM.IGroupConfigurationData;

    constructor({ config, json }: { config: FAM.IGroupConfigurationConfig, json: FAM.IGroupConfigurationData }) {
        super();
        this.config = config;
        this.json = json;
    }

    async before(json: FAM.IGroupConfigurationData): Promise<void> {
        console.debug("[tran] Sprint22Transformer.before")
    }





    async transformBenefit(benefit: FAM.IBenefit): Promise<boolean | void> {
        // is telehealth benefit?
        if (benefit.bcbs_config_categoryid === this.config.cache.map_bcbs_config_category_named['Telehealth'].bcbs_config_categoryid) {

            // map to array of master attributes, first element in array being the visible one.
            const fieldsByMasterAttrId = FieldsToLookupByMasterAttributeId(this.config, benefit.fields);

            // bcbs_telehealthid
            // https://bcbsonline.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=e25c1e1f-a042-ee11-bdf5-000d3a3bec48
            const bcbs_telehealthid_masterAttribiute = fieldsByMasterAttrId['e25c1e1f-a042-ee11-bdf5-000d3a3bec48']
            const bcbs_telehealthid = bcbs_telehealthid_masterAttribiute[0];
            
            let addNotification = false;

            // Blue CareOnDemand:2
            // https://bcbsonline.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_optionsetitem&id=9c93e135-af51-ee11-be6f-000d3a305861
            if (bcbs_telehealthid.field.values[0].value?.type === 'entity' &&
                (bcbs_telehealthid.field.values[0].value?.id === '9c93e135-af51-ee11-be6f-000d3a305861' || bcbs_telehealthid.field.values[0].value?.name === 'Blue CareOnDemand')) {
                addNotification = true;
            }

            // MDLive:6
            // https://bcbsonline.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_optionsetitem&id=c7ab9fba-af51-ee11-be6f-000d3a305861
            if (bcbs_telehealthid.field.values[0].value?.type === 'entity' &&
                (bcbs_telehealthid.field.values[0].value?.id === 'c7ab9fba-af51-ee11-be6f-000d3a305861' || bcbs_telehealthid.field.values[0].value?.name === 'MDLIVE')) {
                addNotification = true;
            }

            if (addNotification) {
                if (!this.json.notifications)
                    this.json.notifications = [];

                this.json.notifications.push({
                    id: uuidv4(),
                    name: 'telehealth-deprecated-fields',
                    location: { benefitId: benefit.id }
                })
            }
        }
    }

    async after(json: FAM.IGroupConfigurationData): Promise<void> {

        console.debug("[tran] Sprint22Transformer.after")

        if (json.transformers)
            json.transformers.Sprint22 = true
    }

}
